import { combineReducers } from 'redux'
import moduleAccess from './moduleAccess'

export default combineReducers({
  moduleAccess,
})
